// Referral numbers (D-114), shared by the Worker, the cron and the billing page copy.
export const REFERRAL_RULES = {
  /** An invited teacher has this long (from the claim) to reach the usage bar. */
  attributionWindowDays: 30,
  /** A first annual payment counts for the inviter up to this long after the claim. */
  paidWindowDays: 180,
  /** "Really using ClassMori": roster size, scoring days, and students scored on each of those days. */
  minStudents: 10,
  minScoringDays: 7,
  minStudentsPerDay: 3,
  qualifyInviterDays: 30,
  qualifyInviteeDays: 7,
  paidInviterDays: 365,
  /** A paid reward waits this long after payment (refund/dispute window) before it is earned. */
  paidConfirmDays: 30,
  /** The inviter's own account must be this old before a paid reward is earned. */
  inviterMinAgeDays: 14,
  /** Usage rewards: at most 12 x 30 days per rolling 365 days. */
  qualifyYearlyCapDays: 360,
  lifetimeCapDays: 6 * 365,
  /** Earned but not yet used time may not exceed this; more waits in line. */
  bankedCapDays: 3 * 365,
  /** Roster-name overlap that marks an invited teacher as the inviter's own account. */
  overlapShare: 0.4,
  overlapMinNames: 8,
  /**
   * Pace (D-176): at most this many usage rewards for one inviter start within any 30 days; more wait in line
   * (pending until room frees up), so a link posted to a big group never loses a real reward but cannot be farmed in a week.
   */
  qualifyMonthlyCount: 3,
  /**
   * Review flags (D-176): only flagged for support, never rejected automatically. Same network / school domain are counted
   * over this many days (as long as the fingerprint is kept), so one fake account a week from home is noticed too.
   */
  reviewWindowDays: 30,
  /** This many sign-ups of one inviter from one network (IPv4 /24, IPv6 /48) within the window. */
  sameNetworkMin: 3,
  /** This many sign-ups of one inviter with the same school (non-public) email domain within the window. */
  sameDomainMin: 3,
  /** This many sign-ups of one inviter within 24 hours. */
  burstCount: 5,
  /** A flagged invite's usage reward for the inviter waits this many more days, so support can look first. */
  reviewHoldDays: 7,
  /** The network fingerprint (a keyed hash, never the address) and the school email domain are erased this long after the sign-up. */
  networkKeyDays: 30,
} as const;

/** Public mailboxes: sharing one of these says nothing about two teachers being the same person or school. */
export const PUBLIC_EMAIL_DOMAINS: ReadonlySet<string> = new Set([
  "gmail.com", "googlemail.com", "yahoo.com", "yahoo.com.tw", "yahoo.com.hk", "hotmail.com", "hotmail.com.tw", "outlook.com",
  "live.com", "msn.com", "icloud.com", "me.com", "mac.com", "proton.me", "protonmail.com", "aol.com", "gmx.com", "gmx.de",
  "mail.com", "yandex.com", "qq.com", "163.com", "126.com", "naver.com", "hinet.net", "msa.hinet.net", "pchome.com.tw",
  "seed.net.tw", "orange.fr", "free.fr", "laposte.net", "sfr.fr", "wanadoo.fr", "hotmail.fr", "yahoo.fr", "outlook.fr",
  "hotmail.es", "yahoo.es", "outlook.es", "hotmail.co.uk", "yahoo.co.uk", "btinternet.com",
]);
